var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    staticClass: "px-1",
    attrs: {
      "max-width": "1140px",
      "width": "100%",
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "headline text-start mt-8"
  }, [_c('span', [_vm._v("유통데이터 활용 소개")])]), _c('section', {
    staticClass: "mt-4"
  }, [_c('div', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("행사 소개")]), _c('v-card', {
    staticClass: "mt-1"
  }, [_c('v-card-text', [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "hide-details": "",
      "rows": "2"
    },
    model: {
      value: _vm.festa.section2.txt[0],
      callback: function callback($$v) {
        _vm.$set(_vm.festa.section2.txt, 0, $$v);
      },
      expression: "festa.section2.txt[0]"
    }
  })], 1), _c('v-card-text', [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "hide-details": ""
    },
    model: {
      value: _vm.festa.section2.txt[1],
      callback: function callback($$v) {
        _vm.$set(_vm.festa.section2.txt, 1, $$v);
      },
      expression: "festa.section2.txt[1]"
    }
  })], 1)], 1)], 1), _c('section', {
    staticClass: "mt-4"
  }, [_c('div', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("데이터를 활용한 새로운 전략 제시")]), _c('v-card', {
    staticClass: "mt-1"
  }, [_c('v-card-text', [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "hide-details": "",
      "rows": "2"
    },
    model: {
      value: _vm.festa.section1.txt,
      callback: function callback($$v) {
        _vm.$set(_vm.festa.section1, "txt", $$v);
      },
      expression: "festa.section1.txt"
    }
  })], 1)], 1)], 1), _c('section', {
    staticClass: "mt-8"
  }, [_c('v-layout', {
    attrs: {
      "align-end": ""
    }
  }, [_c('div', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("행사 개요")]), _c('v-spacer')], 1), _c('v-card', {
    staticClass: "mt-2"
  }, [_c('v-row', {
    key: _vm.index,
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "2"
    }
  }), _c('v-col'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "mr-4",
    attrs: {
      "small": "",
      "color": "primary",
      "elevation": "4"
    },
    on: {
      "click": function click($event) {
        return _vm.$set(_vm.festa.section3.table.list, _vm.festa.section3.table.list.length, {});
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "size": "16"
    }
  }, [_vm._v("mdi-plus")]), _vm._v("추가")], 1)], 1)], 1), _c('v-divider'), _c('v-card-text', {
    staticClass: "py-0"
  }, [_vm._l(_vm.festa.section3.table.list, function (item, index) {
    return [_c('v-row', {
      key: index,
      attrs: {
        "align": "center"
      }
    }, [_c('v-col', {
      attrs: {
        "cols": "2"
      }
    }, [_c('v-textarea', {
      attrs: {
        "rows": "1",
        "dense": "",
        "outlined": "",
        "hide-details": ""
      },
      model: {
        value: item.title,
        callback: function callback($$v) {
          _vm.$set(item, "title", $$v);
        },
        expression: "item.title"
      }
    })], 1), _c('v-col', [_c('v-textarea', {
      attrs: {
        "rows": "1",
        "dense": "",
        "outlined": "",
        "hide-details": ""
      },
      model: {
        value: item.input,
        callback: function callback($$v) {
          _vm.$set(item, "input", $$v);
        },
        expression: "item.input"
      }
    })], 1), _c('v-col', {
      attrs: {
        "cols": "auto"
      }
    }, [_c('v-btn', {
      attrs: {
        "small": "",
        "outlined": "",
        "color": "red"
      },
      on: {
        "click": function click($event) {
          return _vm.festa.section3.table.list.splice(index, 1);
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "left": "",
        "size": "16"
      }
    }, [_vm._v("mdi-delete-outline")]), _vm._v("삭제")], 1)], 1)], 1)];
  })], 2)], 1)], 1), _c('section', {
    staticClass: "mt-4"
  }, [_c('div', {
    staticClass: "subtitle-2 font-weight-bold"
  }, [_vm._v("경진대회 주요 자료")]), _c('v-card', {
    staticClass: "mt-1"
  }, [_c('v-card-text', [_c('v-textarea', {
    attrs: {
      "outlined": "",
      "hide-details": "",
      "rows": "2"
    },
    model: {
      value: _vm.festa.section4.txt,
      callback: function callback($$v) {
        _vm.$set(_vm.festa.section4, "txt", $$v);
      },
      expression: "festa.section4.txt"
    }
  })], 1)], 1)], 1), _c('v-row', {
    staticClass: "mx-1 my-4",
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "md": "auto",
      "sm": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "dark": "",
      "color": "blue darken-2",
      "elevation": "4"
    },
    on: {
      "click": function click($event) {
        return _vm.save();
      }
    }
  }, [_vm._v("저장")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }